import Logo from "@/assets/CareSync.svg?react";
import Logout from "./assets/logout.svg?react";
import CareSyncInsight from "./assets/CareSync-Insight.svg?react";
import InterHospitalIcon from "./assets/interHospitalIcon.svg?react";
import TransferIcon from "./assets/transferIcon.svg?react";
import InsightIcon from "./assets/insightIcon.svg?react";

import { Profile } from "../Profile";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { tw } from "@/utils";
import { useGetTransferCounts } from "@/api/insight";
import { useTransferCountsStore } from "@/store/TransferCounts";

export const LeftNavBar = () => {
  const navigate = useNavigate();
  const path = window.location.pathname;
  const { data, isSuccess } = useGetTransferCounts();
  const { transferStatusCounts, settransferStatusCounts } =
    useTransferCountsStore();

  const [currentPage, setCurrentPage] = useState<string>(path);

  useEffect(() => {
    // setCurrentPage(path);
    if (path === "/") {
      navigate("/careInsight");
      setCurrentPage("careInsight");
    } else {
      setCurrentPage(path.split("/")[1]);
    }
  }, [path]);

  useEffect(() => {
    if (isSuccess) {
      // settransferStatusCounts(data.result.data);
    }
  }, [isSuccess]);

  return (
    <div
      className={tw(
        "flex flex-col w-full h-full bg-gray-g10",
        "border-solid border-r-[1px] border-gray-g50"
      )}
    >
      {/* 테이블 헤더 76px과 통일 */}
      <div
        className={tw(
          "w-full h-[76px]",
          "border-solid border-b-[1px] border-gray-g50"
        )}
      >
        <Profile />
      </div>
      <div className="flex flex-col w-full h-[calc(100%-76px)] px-[10px] pt-[34px] pb-[26px]">
        <nav className="flex flex-col w-full h-[calc(100%-48px)] gap-[20px]">
          <button
            className={tw(
              "w-full h-[44px] px-[18px] py-[4px] rounded-[10px] flex items-center ",
              currentPage === "careInsight" && "bg-gray-g30"
            )}
            onClick={() => navigate("careInsight")}
          >
            <div className="w-[calc(100%-38px)] h-full items-center flex gap-[6px]">
              <InsightIcon
                className={tw(
                  "fill-gray-g200",
                  currentPage === "careInsight" && "fill-gray-g400"
                )}
              />
              <div
                className={tw(
                  "text-gray-g100 font-semibold text-base",
                  currentPage === "careInsight" && "text-gray-g500"
                )}
              >
                {"구급이송 요청"}
              </div>
            </div>
            {transferStatusCounts.in_progress !== 0 && (
              <div
                className={tw(
                  "flex items-center justify-center",
                  "w-[20px] h-[20px] rounded-full text-white text-xs font-medium ml-auto bg-red leading-[16px]"
                )}
              >
                {transferStatusCounts.in_progress}
              </div>
            )}
          </button>
          {/* <button
            className={tw(
              "w-full h-[44px] px-[18px] py-[4px] rounded-[10px] flex items-center ",
              currentPage === "interHospital" && "bg-gray-g30"
            )}
            onClick={() => navigate("interHospital")}
          >
            <div className="w-[calc(100%-38px)] h-full items-center flex gap-[6px]">
              <InterHospitalIcon
                className={tw(
                  "fill-gray-g200",
                  currentPage === "interHospital" && "fill-gray-g400"
                )}
              />
              <div
                className={tw(
                  "text-gray-g100 font-semibold text-base",
                  currentPage === "interHospital" && "text-gray-g500"
                )}
              >
                {"기관전원 요청"}
              </div>
            </div>
            {3 !== undefined && (
              <div
                className={tw(
                  "flex items-center justify-center",
                  "w-[20px] h-[20px] rounded-full text-white text-xs font-medium ml-auto bg-red leading-[16px]"
                )}
              >
                {3}
              </div>
            )}
          </button> */}
          <div className="w-full h-[1px] bg-gray-g30" />
          <button
            className={tw(
              "w-full h-[44px] px-[18px] py-[4px] rounded-[10px] flex items-center ",
              currentPage === "transferring" && "bg-gray-g30"
            )}
            onClick={() => navigate("transferring")}
          >
            <div className="w-[calc(100%-38px)] h-full items-center flex gap-[6px]">
              <TransferIcon
                className={tw(
                  "fill-gray-g200",
                  currentPage === "transferring" && "fill-gray-g400"
                )}
              />
              <div
                className={tw(
                  "text-gray-g100 font-semibold text-base",
                  currentPage === "transferring" && "text-gray-g500"
                )}
              >
                {"현재 이송 중"}
              </div>
            </div>
          </button>
        </nav>
        <div className="flex items-center w-full h-[22px] px-[18px] mt-[26px]">
          <Logo className="w-[25.4px] h-full" />
          <CareSyncInsight className="ml-[3.5px]" />
          <button
            className="ml-auto pl-[12px]"
            onClick={() => {
              // 로그아웃 구현
              alert("로그아웃");
            }}
          >
            <Logout className="w-[18px] h-[18px]" />
          </button>
        </div>
      </div>
    </div>
  );
};
